import { Button, Dialog, IconButton, Tooltip } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import CloseIcon from '@mui/icons-material/Close';
import { Container } from 'react-bootstrap';
import ApiFetch from '../ApiFetch';
import { planDialog } from '../../service/CommonUtil';
import { t } from 'i18next';
import CommonDialog from '../common/CommonDialog';

function PostLimit(props) {
  async function getPostInfo(type){
    return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/postInfo").then((r)=>r.json().then((json)=>{
        return json
    }))
  }
  const[postInfo,setPostInfo] = useState([])
  const[postCount,setPostCount] = useState(0)
  const[limitCount,setLimitCount] = useState(0)
  // ダイアログ
  const [show, setShow] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [okButtonShow,setOkButtonShow] = useState(false)
  function dialog(title,message){
      setDialogTitle(title)
      setDialogMessage(message)
      setShow(true)
  }
  useEffect(() => {
        getPostInfo("image").then(r => {
            if(r.result){
                setPostInfo(r.data)
                setPostCount(r.data.count)
                if(r.data.plan === "" || r.data.plan === "basic"){
                    setLimitCount(150)
                } else if(r.data.plan === "certification") {
                    setLimitCount(350)
                } else if(r.data.plan === "unlimited" || r.data.plan === "plus") {
                    setLimitCount(1000)
                }
                if(r.data.certified_creator === 1){
                    setLimitCount(999999)
                }
            } else {
                setPostInfo([])
                setPostCount(0)
                setLimitCount(150)
            }
        })
  }, []);

  return (
    <Container>
      <CommonDialog title={dialogTitle} content={dialogMessage} open={show} onClick={() => setShow(false)} onClose={() => setShow(false)} />
      直近1か月の投稿枚数：{postCount > limitCount && postInfo.certified_creator === 0 ? <span style={{fontWeight:"bold",color:"red"}}>{postCount}</span> : postCount} / {postInfo.certified_creator === 1 ? <Icon.Infinity style={{fontWeight:"bold",color:"blue",fontSize:"20px"}} /> : <span style={{fontWeight:"bold",color:"blue",fontSize:"20px"}}>{limitCount}</span>}
      {postInfo.certified_creator === 1 ? <Icon.ShieldFillCheck
      onClick={() => dialog(t("common.info"),"投稿枚数無制限の公認クリエイター特典")}
      style={{"inline" : "none",color:"green",cursor:"pointer",marginLeft:"10px"}}
      title="投稿枚数無制限の公認クリエイター特典" /> : ""}
      {postInfo.certified_creator === 0 && (postInfo.plan === "certification" || postInfo.plan === "unlimited" || postInfo.plan === "plus") ? <Icon.CheckCircleFill
      onClick={() => dialog(t("common.info"),"投稿枚数上限アップの課金プラン特典")}
      style={{"inline" : "none",color:"#E2B719",cursor:"pointer",marginLeft:"10px"}}
      title="投稿枚数上限アップの課金プラン特典" /> : ""}
      {postInfo.certified_creator === 0 && (postInfo.plan === "" || postInfo.plan === "basic" || postInfo.plan === "certification") ? <Icon.PlusCircle style={{color:"blue",fontSize:"18px",cursor:"pointer",marginLeft:"10px"}} onClick={() => planDialog(dialog)} /> : ""}
    </Container>
  );
}

export default PostLimit;
